// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8fc67fe2","453":"a01c048c","667":"26a52597","977":"8a6dfd69"}[chunkId] + ".chunk.js";
};